import React, { Component } from "react";
import Button from "@p1s/p1s-common-react/Button";
import PropTypes from "prop-types";
import TextInput from "../../../controls/TextInput";
import ServerError from "../../common/ServerError";
import ValidationHelper from "../../../utilities/ValidationHelper";
import UrlHelper from "../../../utilities/UrlHelper";
import { isEnterPressed, isNumberKeyFromEvent } from "../../../utilities/EventsHelper";
import { pinValidation } from "../../validation/AccountValidations";
import { UserValidationConfiguration } from "../../../configurations/UserValidationConfiguration";

export class SetPin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            validationError: "",
            pin: "",
            isTyping: ""
        };

        this.isAcceptableKey = this.isAcceptableKey.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
    }

    isAcceptableKey (event) {
        if (isEnterPressed(event)) {
            this.onComplete();
        }
        else if (!isNumberKeyFromEvent(event)) {
            event.preventDefault();
        }
    }

    onComplete () {
        const validationResult = pinValidation(this.state.pin);

        let validationError = undefined;

        if (validationResult.isValid){
            const ticket = UrlHelper.getParameterByName("ticket");
            if (!ValidationHelper.isNullOrEmpty(ticket)) {
                this.props.validatePin(this.state.pin, ticket);
            }
        }
        else if (!validationResult.isValid){
            validationError = validationResult.error;
        }

        this.setState({
            validationError: validationError,
            isTyping: ""
        });
    }

    onTextChange(e) {
        if (e && e.target) {
            var pin = e.target.value;
            const validationResult = pinValidation(pin);

            let validationError = undefined;

            if (!validationResult.isValid)
                validationError = validationResult.error;

            this.setState({
                validationError: validationError,
                pin: pin,
                isTyping: true
            });
        }
    }

    render() {
        const serverError = this.props.serverError;
        const errorSummary = this.props.errorSummary;
        const validationError = this.state.validationError;
        const pin = this.state.pin;
        const email = this.props.email;

        const isTyping = this.state.isTyping;
        const hasServerError = serverError != null && serverError.length > 0;
        const hasValidationError = validationError != null && validationError.length > 0;
        return (
            <div id="pinNumberBlock" className="account-popup">
                <div className="signIn-form-title">PIN Number</div>
                <div className="signIn-form-info">
                    <div>
                        <span className="email"><b>{email}</b></span>
                    </div>
                    <div className="input-row">
                        <span>For security reasons, you are required to enter a PIN number to create your account.
                            This number should have been given to you by an administrator.</span>
                    </div>
                </div>
                <div className="input-row" >
                    <TextInput
                        name="pin"
                        label=""
                        tabIndex={1}
                        autoFocus={true}
                        error={validationError}
                        placeholder="Enter PIN"
                        maxlength={UserValidationConfiguration.pinMaxLength}
                        onChange = {this.onTextChange}
                        onKeyPress={this.isAcceptableKey}
                        value = {pin}
                        inputClassName={"picker-hollow"}
                    />
                </div>
                <div className="button-container">
                    <Button name="btnSetPin" className="btn btn-primary-action pull-right" onClick={this.onComplete} title={"Next"}/>
                </div>
                <ServerError
                    errorSummary={errorSummary}
                    serverError={serverError}
                    isVisible={!isTyping && hasServerError && !hasValidationError}/>
            </div>
        );
    }
}

SetPin.propTypes = {
    email: PropTypes.string,
    serverError: PropTypes.string,
    errorSummary: PropTypes.string,
    validatePin: PropTypes.func
};

export default SetPin;
